import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["option", "selected"];
import * as React from 'react';
import { useDeviceType } from '../../../../responsive';
import { Sucess16 } from '../../../../prev/icons';
import { getStyles } from './styles';
export function SingleSelectItem(props) {
  var option = props.option,
    selected = props.selected,
    divProps = _objectWithoutProperties(props, _excluded);
  var deviceType = useDeviceType();
  var styles = getStyles(deviceType);
  return /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
    className: styles['item']
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['label']
  }, /*#__PURE__*/React.createElement("div", null, option.label), option.description && /*#__PURE__*/React.createElement("div", {
    className: styles['description']
  }, option.description)), selected && /*#__PURE__*/React.createElement("div", {
    className: styles['selected-indicator']
  }, /*#__PURE__*/React.createElement(Sucess16, {
    color: "current_color"
  })));
}